import React, { useContext } from "react";
import "./Header.scss";
import { ReactComponent as Logo } from "../../assets/media/logo.svg";
import { I18nContext } from "../../context";

/**
 * Header with logo
 * @param {Object} props
 * @param {String} props.logoUrl Link wrapping logo
 * @returns {React.ReactElement}
 */
function Header({ logoUrl }) {
  const { locale } = useContext(I18nContext);

  return (
    <header className="Header">
      <a href={logoUrl} className="Header__logo" aria-label={locale.logoLabel}>
        <Logo className="Header__logo-img" />
      </a>
    </header>
  );
}

export default Header;
